import React/*, { useEffect }*/ from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
// import { setIsLoginTypeModal } from '../../store/reducers/authSlice';

function Book(props) {
    const location = useLocation();
    const isAuth = useSelector(state=> state.auth.isAuth);
    // const dispatch = useDispatch();

    /*useEffect(() => { // попросили выключить необходимость авторизации
        if(!isAuth) {
            dispatch(setIsLoginTypeModal(true));
        }
    }, [dispatch, isAuth]);*/

    let { id } = useParams();
    const bookUrl = `https://books.oqulyqtar.kz/${id}/`

    return (
        <>
            {
               isAuth || true // попросили выключить необходимость авторизации
                   ? <iframe title="site" src={location.state?.url || bookUrl} className="w-[100vw] h-[calc(100vh-57px)] box-border overflow-x-hidden" allowFullScreen></iframe>
                   : <div className="w-[100vw] h-[calc(100vh-57px)] box-border overflow-x-hidden">
                    <h1 className="text-2xl text-center pt-8">Для просмотра учебника необходимо авторизоваться</h1>
                   </div>
            }
        </>
    );
}

export default Book;
